import { truckColNm } from "constants/truckConstant"
import dayjs from "dayjs";



export const goNexColumns = [
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "LicNm",
    headerName: truckColNm.LicNm,
    width: 100,
  },
  {
    field: "InTm",
    headerName: "วันเวลาเข้า",
    width: 150,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM/YYYY HH:mm") : "-";
    },
  },
  {
    field: "OutTm",
    headerName: "วันเวลาออก",
    width: 150,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM/YYYY HH:mm") : "-";
    },
  },
  {
    field: "hrs",
    headerName: "ระยะเวลา (ชม.)",
    width: 100,
    align: "center",
    valueGetter: ({row})=>{
      if(row.InTm && row.OutTm){
        const inTm = dayjs(row.InTm)
        const outTm = dayjs(row.OutTm)
        const diff = outTm.diff(inTm, "minute")
        return Math.round(diff / 60).toString()
      }
    }
  },
]

export const nwSummaryColumns = [
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "LicNm",
    headerName: truckColNm.LicNm,
    width: 100,
  },
  {
    field: "Num",
    headerName: "จำนวนวัน",
    width: 80,
  },
  {
    field: "TotalDist",
    headerName: "รวมระยะทาง (กม.)",
    width: 80,
  },
  {
    field: "DteDistStr",
    headerName: "รายละเอียดวันที่ (ระยะทาง กม.)",
    flex: 1,
  },
]


export const nwColumns = [
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "LicNm",
    headerName: truckColNm.LicNm,
    width: 100,
  },
  {
    field: "TukDte",
    headerName: "วันที่",
    width: 150,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM/YYYY") : "-";
    },
  },
  {
    field: "TukDay",
    headerName: "วัน",
    width: 80,
    valueGetter: ({row}) => {
      return dayjs(row.TukDte).format("dddd")
    }
  },
  {
    field: "Dist",
    headerName: "ระยะทาง (กม.)",
    width: 100,
    align: "right",
  },
]